import { Roles } from '@/router/roles';

const groupParams = (to) => ({ groupNumber: to.params.groupNumber });

export const refAdminRoutes = [
	{
		path: 'admin',
		name: 'Admin',
		meta: Roles.REFADMIN,
		component: () => import('@/views/RefereeAdmin/AdminDashboard/AdminDashboard.vue')
	},
	{
		path: 'admin/view-clients/group/:groupNumber',
		name: 'View Clients',
		meta: Roles.REFADMIN,
		component: () => import('@/views/RefereeAdmin/ViewClients/AdminViewClients.vue'),
		props: true
	},
	{
		path: 'admin/view-game-settings/group/:groupNumber',
		name: 'View Game Settings',
		meta: Roles.REFADMIN,
		component: () => import('@/views/RefereeAdmin/ViewGameSettings/AdminViewGameSettings.vue'),
		props: true
	},
	{
		path: 'admin/view-group-settings/group/:groupNumber',
		name: 'Admin View Group Settings',
		meta: Roles.REFADMIN,
		component: () => import('@/views/RefereeAdmin/ViewSettings/AdminViewGroupSettings.vue'),
		props: true
	},
	{
		path: 'admin/view-game-settings/match-fee/group/:groupNumber',
		name: 'Admin View Match Fees',
		meta: Roles.REFADMIN,
		component: () => import('@/views/MatchFees/Fees.vue'),
		props: true
	},
	{
		path: 'admin/view-game-settings/match-duration/group/:groupNumber',
		name: 'Admin View Match Durations',
		meta: Roles.REFADMIN,
		component: () => import('@/views/MatchDuration/Durations.vue'),
		props: true
	},
	{
		path: 'admin/view-game-settings/upload-setting/group/:groupNumber',
		name: 'Admin View Upload Settings',
		meta: Roles.REFADMIN,
		component: () => import('@/views/UploadSettings/uploadSettings.vue'),
		props: true
	},
	{
		path: 'admin/view-game-settings/patterns/group/:groupNumber',
		name: 'Admin View Patterns',
		meta: Roles.REFADMIN,
		component: () => import('@/views/AssignmentPatterns/AssignmentPatterns.vue'),
		props: true
	},
	{
		path: 'admin/view-games/group/:groupNumber',
		name: 'Admin View Assigning Datatable',
		meta: Roles.REFADMIN,
		component: () => import('@/views/AssigningDatatable/AssigningDatatable.vue'),
		props: true
	},

	// ---- Finance (V3) -------------------------------------------------------
	{
		path: 'admin/finance',
		name: 'Finance',
		meta: Roles.REFADMIN,
		redirect: () => ({ name: 'Finance Section', params: { section: 'home' } })
	},
	{
		path: 'admin/finance/:section(home|review|invoices|payouts|ledger|reports|settings)',
		name: 'Finance Section',
		meta: Roles.REFADMIN,
		component: () => import('@/finance/views/FinanceGroupResolver.vue'),
		props: true
	},
	{
		path: 'admin/finance/home/group/:groupNumber',
		name: 'Finance Home',
		meta: Roles.REFADMIN,
		component: () => import('@/finance/views/FinanceHome.vue'),
		props: true
	},
	{
		path: 'admin/finance/review/group/:groupNumber',
		name: 'Finance Review',
		meta: Roles.REFADMIN,
		component: () => import('@/finance/views/ReviewPage.vue'),
		props: true
	},
	{
		path: 'admin/finance/invoices/group/:groupNumber',
		name: 'Finance Invoices',
		meta: Roles.REFADMIN,
		component: () => import('@/finance/views/InvoicesList.vue'),
		props: true
	},
	{
		path: 'admin/finance/invoices/new/group/:groupNumber',
		name: 'Finance Invoice Composer',
		meta: Roles.REFADMIN,
		component: () => import('@/finance/views/InvoiceComposer.vue'),
		props: true
	},
	{
		path: 'admin/finance/invoices/group/:groupNumber/invoice/:batchId',
		name: 'Finance Invoice Detail',
		meta: Roles.REFADMIN,
		component: () => import('@/finance/views/InvoiceDetail.vue'),
		props: true
	},
	{
		path: 'admin/finance/invoices/group/:groupNumber/invoice/:batchId/edit',
		name: 'Finance Invoice Edit',
		meta: Roles.REFADMIN,
		component: () => import('@/finance/views/InvoiceComposer.vue'),
		props: true
	},
	{
		path: 'admin/finance/payouts/group/:groupNumber',
		name: 'Finance Payouts',
		meta: Roles.REFADMIN,
		component: () => import('@/finance/views/PayoutsPage.vue'),
		props: true
	},
	{
		path: 'admin/finance/payouts/group/:groupNumber/batch/:batchId',
		name: 'Finance Payout Batch',
		meta: Roles.REFADMIN,
		component: () => import('@/finance/views/PayoutBatchPage.vue'),
		props: true
	},
	{
		path: 'admin/finance/reports/group/:groupNumber',
		name: 'Finance Reports',
		meta: Roles.REFADMIN,
		component: () => import('@/finance/views/FinanceReports.vue'),
		props: true
	},
	{
		path: 'admin/finance/ledger/group/:groupNumber',
		name: 'Finance Ledger',
		meta: Roles.REFADMIN,
		component: () => import('@/finance/views/LedgerPage.vue'),
		props: true
	},
	{
		path: 'admin/finance/settings/group/:groupNumber',
		name: 'Finance Settings',
		meta: Roles.REFADMIN,
		component: () => import('@/finance/views/FinanceSettings.vue'),
		props: true
	},

	// ---- Legacy finance paths: keep bookmarks working -----------------------
	{
		path: 'admin/view-payments/group/:groupNumber',
		name: 'View Payments',
		meta: Roles.REFADMIN,
		redirect: (to) => ({ name: 'Finance Home', params: groupParams(to) })
	},
	{
		path: 'admin/review-work/group/:groupNumber',
		name: 'Review Work',
		meta: Roles.REFADMIN,
		redirect: (to) => ({ name: 'Finance Review', params: groupParams(to) })
	},
	{
		path: 'admin/bulk-payments/group/:groupNumber',
		name: 'Process Bulk Payments',
		meta: Roles.REFADMIN,
		redirect: (to) => ({ name: 'Finance Payouts', params: groupParams(to) })
	},
	{
		path: 'admin/invoicing/group/:groupNumber',
		name: 'Invoicing',
		meta: Roles.REFADMIN,
		redirect: (to) => ({ name: 'Finance Invoices', params: groupParams(to) })
	},
	{
		path: 'admin/invoicing/group/:groupNumber/invoice/:batchId',
		name: 'Invoice Detail',
		meta: Roles.REFADMIN,
		redirect: (to) => ({ name: 'Finance Invoice Detail', params: { groupNumber: to.params.groupNumber, batchId: to.params.batchId } })
	},
	{
		path: 'admin/finance-reports/group/:groupNumber',
		name: 'Legacy Finance Reports',
		meta: Roles.REFADMIN,
		redirect: (to) => ({ name: 'Finance Reports', params: groupParams(to) })
	},

	{
		path: 'admin/view-users/group/:groupNumber',
		name: 'View Users',
		meta: Roles.REFADMIN,
		component: () => import('@/views/UsersDatatable/UserDirectory.vue'),
		props: true
	},
	{
		path: 'locations',
		name: 'Admin Locations',
		meta: Roles.REFADMIN,
		component: () => import('@/views/EvergreenSports/Locations/Locations.vue')
	},
	{
		path: '/app/admin/group/:groupNumber/assigning/fields',
		name: 'Admin Field Assigning View',
		component: () => import('@/views/AssigningDatatable/components/FieldAssigningTab.vue')
	}
];
